import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

import {getUserInfoRoles, getUserToken} from '../reducers/user/selectors';

export default WrappedComponent => {
  const IsAuthenticated = ({ userToken, userInfoRoles, ...props }) => {
    if (userToken) {
      if (userInfoRoles.includes('Patient')) {
        return <Redirect to={'/patient/dashboard'} />;
      } else {
        return <Redirect to={'/admin'} />;
      }
    }

    return <WrappedComponent {...props} />;
  };

  return connect((state) => ({
    userToken: getUserToken(state),
    userInfoRoles: getUserInfoRoles(state),
  }))(IsAuthenticated);
};



// WEBPACK FOOTER //
// ./src/utils/isNotAuthenticated.js